module.exports = __webpack_public_path__ + "img/27_56.7c9095a1.png";